<template>
  <Modal
    :id="'cmp-catalog-products-product_export'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('products_advanced_search')}}</template>

    <template slot="body">
      <div class="form-group">
        <Dropdown
          class="dt-dropdown m2"
          :options="advancedSearchData.labelsTV"
          :selected="
            advancedSearchData.labelsTV.find(
              (c) => c.value == label_id
            )
          "
          box
          :placeholder="$t('label')"
          v-on:selectedChange="
            (e) => onDropdownChange('label_id', e)
          "
          :listHeight="150"
        ></Dropdown>
        <div class="ut-flex">
          <TextField
            class="m1"
            :type="'date'"
            style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            :id="'start_date'"
            v-bind="textFieldConfig"
            :value="start_date"
            @valuechanged="onTextFieldValueChange"
            :placeholder="$t('start_date')"
          />
          <TextField
            class="m1"
            :type="'date'"
            style="
              margin-right: 0px !important;
              margin-left: 5px !important;
              flex: 1;
            "
            :id="'end_date'"
            v-bind="textFieldConfig"
            :value="end_date"
            @valuechanged="onTextFieldValueChange"
            :placeholder="$t('end_date')"
          />
        </div>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.formatsTV"
          :selected="
            advancedSearchData.formatsTV.find(
              (c) => c.value == format_id
            )
          "
          box
          :placeholder="$t('format')"
          v-on:selectedChange="
            (e) => onDropdownChange('format_id', e)
          "
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.channelsTV"
          :selected="
            advancedSearchData.channelsTV.find(
              (c) => c.value == channel
            )
          "
          box
          :placeholder="$t('channel')"
          v-on:selectedChange="
            (e) => onDropdownChange('channel', e)
          "
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.product_typesTV"
          :selected="
            advancedSearchData.product_typesTV.find(
              (c) => c.value == category_1
            )
          "
          box
          :placeholder="$dft.capHead($t('category'))"
          v-on:selectedChange="
            (e) => onDropdownChange('category_1', e)
          "
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.product_types2TV"
          :selected="
            advancedSearchData.product_types2TV.find(
              (c) => c.value == category_2
            )
          "
          box
          :placeholder="$t('category_2')"
          v-on:selectedChange="
            (e) => onDropdownChange('category_2', e)
          "
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.price_listsTV"
          :selected="
            advancedSearchData.price_listsTV.find(
              (c) => c.value == price_list_id
            )
          "
          box
          :placeholder="$t('price_list')"
          v-on:selectedChange="
            (e) => onDropdownChange('price_list_id', e)
          "
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.stock_locationsTV"
          :selected="
            advancedSearchData.stock_locationsTV.find(
              (c) => c.value == stock_location_id
            )
          "
          box
          :placeholder="$t('stock_location')"
          v-on:selectedChange="
            (e) => onDropdownChange('stock_location_id', e)
          "
          :listHeight="150"
        ></Dropdown>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
      <button
        class="dt-button v1 s6"
        @click.stop="onExportClick"
      >
        {{$t('export')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { ProductsService } from "../../services/products.service";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import { DTIconButton } from "../../../../plugins/button/button";
import FileDownload from "js-file-download";

export default {
  components: {
    Modal,
    DTCheckbox,
    DTIconButton,
  },
  props: {
    advancedSearchData: {
      type: Object,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      validationResult: {},

      label_id: "",
      start_date: "",
      end_date: "",
      format_id: "",
      channel: "",
      category_1: "",
      category_2: "",
      price_list_id: "",
      stock_location_id: "",
    };
  },
  mounted: async function () {},
  computed: {
    exportFilters: function () {
      return {
        label_id: this.label_id,
        start_date: this.start_date,
        end_date: this.end_date,
        format_id: this.format_id,
        channel: this.channel,
        category_1: this.category_1,
        category_2: this.category_2,
        price_list_id: this.price_list_id,
        stock_location_id: this.stock_location_id,
      };
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },
    onExportClick: function () {
      ProductsService.exportProduct(this.exportFilters).then(
        (res) => {
          FileDownload(res.data, "catalog_report.xlsx");
          this.onCancel();
        }
      );
    },
    onTextFieldValueChange: function (key, value) {
      this[key] = value;
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
</style>
